import { render } from "./Blog_details.vue?vue&type=template&id=f6022c10"
import script from "./Blog_details.vue?vue&type=script&lang=js"
export * from "./Blog_details.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__